import { Axios } from "@/utils/axios";
import { queryKeys } from "goi_common";
import { useQuery } from "react-query";

type ServerTimeResponse = { timestamp: Date; is_night: boolean };

export const useGetServerTime = () => {
  return useQuery<ServerTimeResponse>(queryKeys.nightTime(), async () => {
    const response = await Axios.get("/now_time/");
    return response.data;
  });
};
